// @ts-nocheck
import {Logger} from '@utils/logger';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tmz from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(tmz);

export const DATE_FORMAT = {
  DATE: 'MM/DD/YYYY',
  SCHEDULED: 'ddd MM/DD/YYYY [at] h:mma',
  INVALID: 'Invalid Date',
};

type ScheduledFormat = Partial<{
  timezone: string;
  format: string;
}>;

/**
 * Scheduled Format
 * Will return the following display: Wed 12/18/2019 at 4:00pm"
 * @param date
 * @param timezone
 * @param format
 * @returns {string}
 */
export const scheduledFormat = (date: Date | string | number, {timezone, format = DATE_FORMAT.SCHEDULED}: ScheduledFormat = {}) => {
  let formattedDate;

  try {
    formattedDate = timezone ? dayjs.tz(date, timezone).format(format) : dayjs(date).format(format);
  } catch (e) {
    formattedDate = DATE_FORMAT.INVALID;
    Logger('scheduledFormat')(e);
  }

  return formattedDate === DATE_FORMAT.INVALID ? '' : formattedDate;
};

/**
 * Use format for date display
 *
 * @param timestamp
 * @param format
 * @returns {*}
 */
export const displayTimestamp = (timestamp: string | number, format = DATE_FORMAT.DATE) => dayjs(timestamp).format(format);

/**
 * Returns estimated delivery based on delivery days
 *
 * @param startDate? defaults to now
 * @param daysToAdd? defaults to 3
 * @returns {string}
 */
export const addBusinessDays = (startDate = new Date(), daysToAdd = 3) => {
  let count = 0;
  let deliveryDate;
  while (count < daysToAdd) {
    const sunday = 0;
    const saturday = 6;
    deliveryDate = new Date(startDate.setDate(startDate.getDate() + 1));
    const dayOfTheWeek = deliveryDate.getDay();
    const isWeekday = dayOfTheWeek !== sunday && dayOfTheWeek !== saturday;
    if (isWeekday) {
      count += 1;
    }
  }
  return deliveryDate.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
};
